/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsOrphanedOciAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsOrphanedOciAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsOrphanedOciAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsOrphanedOciAdvisorResource>): RecommendationForFinopsOrphanedOciAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsOrphanedOciAdvisorResource(), model);
        RecommendationForFinopsOrphanedOciAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsOrphanedOciAdvisorResource>): RecommendationForFinopsOrphanedOciAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsOrphanedOciAdvisorResource.newInstance(<RecommendationForFinopsOrphanedOciAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsOrphanedOciAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsOrphanedOciAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsOrphanedOciAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsOrphanedOciAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
